import api from './api';

const organicStructureService = {
  async getAll() {
    const response = await api.get('/organic-structure');
    return response.data;
  },

  async create(data) {
    const response = await api.post('/organic-structure', data);
    return response.data;
  },

  async update(id, data) {
    const response = await api.patch(`/organic-structure/${id}`, data);
    return response.data;
  },

  async remove(id) {
    const response = await api.delete(`/organic-structure/${id}`);
    return response.data;
  },
};

export default organicStructureService;
